import { Progress } from '@curology/ui-components-web/react/Progress';
import React, { type MutableRefObject } from 'react';

import { type BrowserPaymentRequestType } from '@/components/payments/hooks/useBrowserPayment';
import { useBrowserPaymentButton } from '@/components/payments/hooks/useBrowserPaymentButton';
import { type BrowserPaymentButtonStyles } from '@/types/payments/types';

const BrowserPaymentButton: React.FC<{
  paymentRequest: MutableRefObject<BrowserPaymentRequestType>;
  onSuccess: (
    token: stripe.paymentRequest.StripeTokenPaymentResponse,
  ) => Promise<void>;
  onClick?: (event: { preventDefault: () => void }) => Promise<void>;
  buttonStyleOptions?: Partial<BrowserPaymentButtonStyles>;
}> = ({ paymentRequest, onSuccess, onClick, buttonStyleOptions }) => {
  const { showButtonLoader, buttonId, buttonContainerId } =
    useBrowserPaymentButton({
      paymentRequest,
      onSuccess,
      onClick,
      buttonStyleOptions,
    });

  return (
    <div className="cur-text-center cur-pt-4">
      <label className="cur-w-full" id={buttonContainerId}>
        <div id={buttonId} />
      </label>
      {showButtonLoader && (
        <Progress
          className="cur-inline-block"
          progressType="circle"
          state="highlight"
        />
      )}
    </div>
  );
};

export default BrowserPaymentButton;
